import PropTypes from 'prop-types'
import { View } from './View'

/**
 * Appkit4 Listコンポーネントは
 * <a href="https://appkit.pwc.com/appkit4/content/list?version=react" target="_blank">こちら</a>
 */
export const List = ({ ...props }) => {
    const { onItemClick } = props
    const handleKeyDown = (key, index, e) => {
        if (e.key === 'Enter') {
            onItemClick && onItemClick(key, index)
        }
    }

    return <View handleKeyDown={handleKeyDown} {...props} />
}

List.propTypes = {
    /**
     * アイテムリスト<font color="red">*</font><br>
     * ※ `content`プロパティは必須
     */
    data: PropTypes.arrayOf(
        PropTypes.shape({
            content: PropTypes.node.isRequired
        })
    ).isRequired,
    /**
     * アイテムのキーとするプロパティ名<br>
     * ※ data に格納しているいずれかのプロパティを指定
     */
    itemKey: PropTypes.string,
    /**
     * アイテムクリック時のハンドラー<br>
     * ※ `itemKey` で指定したプロパティの値を引数で受け取る<br>
     * (itemKey: string) => void
     */
    onItemClick: PropTypes.func,
    /**
     * 背景をダークにするかどうか
     */
    isDark: PropTypes.bool,
    /**
     * リストの横幅
     */
    width: PropTypes.number,
    /**
     * 選択状態にする値<br>
     * ※ `itemKey` で指定したプロパティの値を指定する
     */
    selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /**
     * スタイル変更用のクラス名
     */
    className: PropTypes.any
}

List.defaultProps = {
    isDark: false,
    itemKey: 'content'
}
